import React, { useEffect, useMemo, useRef, useState } from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Alert from "react-bootstrap/Alert";
import axios from "axios";
import Select from 'react-select';
import XLSX from "sheetjs-style";
import * as FileSaver from "file-saver";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import usePersonaManagement from '../hooks/usePersonaManagement'
import "../../assets/css/reportRegistrations.css";

const BULK_TEMPLATE_HEADERS = ["Email", "User Type", "User Group(s)", "Role(s)"];

const UserRegistration = () => {
    const [validated, setValidated] = useState(false);
    const [userType, setuserType] = useState("Member");
    const [EmailAdress, setEmail] = useState("");
    const [isLoading, setIsloading] = useState(false);
    const [issuccess, setsuccess] = useState(false);
    const [iserror, seterror] = useState(false);
    const [userGroup, setuserGroup] = useState("");
    const [RLType, setRLtype] = useState('');
    const [iserrorEmail, setiserrorEmail] = useState(false);
    const [roleList, setRoleList] = useState([]);

    const passtoken = JSON.parse(localStorage.getItem("access-token-storage"))[
      "accessToken"
    ];
    const { personaOptions } = usePersonaManagement(passtoken);

    useEffect(() => {
      let isMounted = true;

      const fetchRoles = async () => {
        try {
          const headers = {
            Accept: "application/json",
          };

          if (passtoken) {
            headers["oidc-token"] = passtoken;
          }

          const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/aipd/role-management/roles`,
            { headers }
          );

          const json = await response.json().catch(() => null);

          if (!response.ok) {
            throw new Error(json?.message || "Failed to fetch roles.");
          }

          let normalizedRoles = [];
          if (Array.isArray(json)) {
            normalizedRoles = json;
          } else if (Array.isArray(json?.data?.roles)) {
            normalizedRoles = json.data.roles;
          } else if (json?.data && Array.isArray(json.data)) {
            normalizedRoles = json.data;
          } else if (Array.isArray(json?.roles)) {
            normalizedRoles = json.roles;
          } else if (json?.data && typeof json.data === "object") {
            normalizedRoles = [json.data];
          } else if (json && typeof json === "object") {
            normalizedRoles = [json];
          }

          if (isMounted) {
            setRoleList(normalizedRoles);
          }
        } catch (error) {
          if (isMounted) {
            setRoleList([]);
          }
        }
      };

      fetchRoles();

      return () => {
        isMounted = false;
      };
    }, [passtoken]);

    const roleOptions = useMemo(() => {
      if (!Array.isArray(roleList)) {
        return [];
      }

      return roleList.map((role) => {
        const roleName = String(role?.role_name || role?.roleName || "").trim();
        const dealerCode = String(role?.dealer_code || role?.dealerCode || "").trim();
        const label = dealerCode && dealerCode !== roleName
          ? `${roleName} (${dealerCode})`
          : roleName;

        return {
          value: roleName,
          label,
        };
      });
    }, [roleList]);
  
   // console.log("passtoken")
    //console.log(userGroup)
  
    useEffect(() => {
      document.title = "User Registration";
    });
  
    var SelectedList = ["daimlertruck.com","tbdir.net"];

    const [bulkRows, setBulkRows] = useState([]);
    const [showBulkModal, setShowBulkModal] = useState(false);
    const [isBulkSaving, setIsBulkSaving] = useState(false);
    const [showDataRules, setShowDataRules] = useState(false);
    const [isBulkSubmitted, setIsBulkSubmitted] = useState(false);
    const fileInputRef = useRef(null);

    const emailid  = localStorage.getItem("myemail");
    const handleSubmit = (event) => {
      event.preventDefault();
      const form = event.currentTarget;
      var splitArray = EmailAdress.split('@');

      // console.log(form);
      if (form.checkValidity() === false) {
        event.preventDefault();
        event.stopPropagation();
      } 
      else {
       
        if(SelectedList.indexOf(splitArray[1]) >= 0){
          setValidated(true);
          setIsloading(true);
  
          const data = {
            emailAddress: EmailAdress.toLowerCase(),
            userType: userType,
            userGroup:selectedPersona1,
            rlType:selectedOptionsDataRl,
            assignUser:emailid
          }
          const url = `${process.env.REACT_APP_SERVER_URL}/aipd/registerUser `;

          const header = {
            headers: {
              "oidc-token": passtoken,
            }
          }
  
          axios.post(url, data, header)
  
            .then(function (response) {
              if (response.status === 201) {
                // console.log(response);
                setIsloading(false)
                setValidated(false)
                setuserType("Member")
                setEmail("")
                setuserGroup("")
                setRLtype("")
                setsuccess(true)
                setTimeout(() => {
                  setsuccess(false);
                }, 10000);
                seterror(false);
              }
            })
            .catch(function (error) {
              // console.log(error);
              setIsloading(false);
              setValidated(false);
              setsuccess(false);
              seterror(true);
              setTimeout(() => {
                seterror(false);
              }, 10000);
            });
        }
        else{
          setiserrorEmail(true)
          setTimeout(() => {
            setiserrorEmail(false)
          }, 5000);

        }
       
      }
      setValidated(true);
    };

   
  
   
    const resetForm = (e) => {
      e.preventDefault();
      setValidated(false)
      setuserType("Member")
      setEmail("")
      setuserGroup("")
      setRLtype("")
      setSelectedOptions([])
      setselectedOptionsData([])
      setselectedOptionsPersona([])
      setselectedPersona([])
    };

   

    const [selectedOptions, setSelectedOptions] = useState([]);
    const [selectedOptionsData, setselectedOptionsData] = useState([]);
    const [selectedOptionsDataRl, setselectedOptionsDataRl] = useState([]);

    const [selectedOptionsPersona, setselectedOptionsPersona] = useState([]);
    const [selectedPersona, setselectedPersona] = useState([]);
    const [selectedPersona1, setselectedPersona1] = useState([]);

    const handleChange = (selectedOptions) => {
      const selectedValues = selectedOptions.map((option) => option.value);
      setSelectedOptions(selectedOptions)
      const userGroupsArrayRLtype = selectedValues.map((value) => ({ "RLtypename": value }));

      setselectedOptionsData(selectedValues);
      setselectedOptionsDataRl(userGroupsArrayRLtype);

    };

    const handleChangePersona = (selectedOptions) => {
      const selectedValues = selectedOptions.map((option) => option.value);
      setselectedOptionsPersona(selectedOptions)
      setselectedPersona(selectedValues);
      const userGroupsArray = selectedValues.map((value) => ({ "userGroupId": value }));

      setselectedPersona1(userGroupsArray);
    };

    const downloadBulkTemplate = () => {
      // User Group(s) holds persona names; they are converted to userGroupId when building the payload
      const templateRows = [
        {
          "Email": "abc@tbdir.net",
          "User Type": "Member",
          "User Group(s)": personaOptions[0]?.label || "Persona Name",
          "Role(s)": "WASAN",
        },
      ];
      if (personaOptions.length > 1 && roleOptions.length > 1) {
        templateRows.push({
          "Email": "xyz@tbdir.net",
          "User Type": "Admin",
          "User Group(s)": personaOptions.slice(0, 2).map((option) => option.label).join(", "),
          "Role(s)": roleOptions.slice(0, 2).map((option) => option.value).join(", "),
        });
      }
      const ws = XLSX.utils.json_to_sheet(templateRows, { header: BULK_TEMPLATE_HEADERS });
      ws["!cols"] = BULK_TEMPLATE_HEADERS.map(() => ({ wch: 30 }));
      const wb = { Sheets: { Users: ws }, SheetNames: ["Users"] };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset-UTF-8",
      });
      FileSaver.saveAs(data, "UserRegistrationTemplate.xlsx");
    };

    const triggerBulkFileSelect = () => {
      fileInputRef.current?.click();
    };

    // resolves a comma-separated cell against select options, matching case-insensitively on the given option fields
    const resolveMultiValues = (cellValue, options, matchFields = ["value", "label"]) => {
      const names = String(cellValue || "")
        .split(",")
        .map((value) => value.trim())
        .filter(Boolean);

      const resolved = [];
      const unresolved = [];

      names.forEach((name) => {
        const lowerName = name.toLowerCase();
        const match = options.find((option) =>
          matchFields.some((field) => String(option[field]).toLowerCase() === lowerName)
        );
        if (match) {
          resolved.push(match);
        } else {
          unresolved.push(name);
        }
      });

      return { names, resolved, unresolved };
    };

    const validateBulkRow = (rawRow, rowNumber) => {
      const errors = [];

      const emailAddress = String(rawRow["Email"] || "").trim();
      const userTypeRaw = String(rawRow["User Type"] || "").trim();
      const userGroupCell = rawRow["User Group(s)"];
      const roleCell = rawRow["Role(s)"];

      if (!emailAddress) {
        errors.push("Email is required");
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailAddress)) {
        errors.push("Invalid email format");
      } else {
        const domain = emailAddress.split("@")[1]?.toLowerCase();
        if (!SelectedList.includes(domain)) {
          errors.push("Email domain must be @daimlertruck.com or @tbdir.net");
        }
      }

      const normalizedUserType =
        userTypeRaw.toLowerCase() === "member"
          ? "Member"
          : userTypeRaw.toLowerCase() === "admin"
          ? "Admin"
          : null;
      if (!normalizedUserType) {
        errors.push("User Type must be Member or Admin");
      }

      const { names: userGroupNames, resolved: userGroupOptions, unresolved: unresolvedGroups } = resolveMultiValues(
        userGroupCell,
        personaOptions,
        ["label"]
      );
      if (userGroupNames.length === 0) {
        errors.push("User Group(s) is required");
      } else if (unresolvedGroups.length > 0) {
        errors.push(`Unknown User Group(s): ${unresolvedGroups.join(", ")}`);
      }

      const { names: roleNamesEntered, resolved: roleSelectOptions, unresolved: unresolvedRoles } = resolveMultiValues(
        roleCell,
        roleOptions
      );
      if (roleNamesEntered.length === 0) {
        errors.push("Role(s) is required");
      } else if (unresolvedRoles.length > 0) {
        errors.push(`Unknown Role(s): ${unresolvedRoles.join(", ")}`);
      }

      return {
        rowNumber,
        emailAddress,
        userType: normalizedUserType || userTypeRaw,
        userGroupLabels: userGroupOptions.map((option) => option.label).join(", "),
        roleLabels: roleSelectOptions.map((option) => option.label).join(", "),
        userGroupIds: userGroupOptions.map((option) => ({ userGroupId: option.value })),
        roleNames: roleSelectOptions.map((option) => ({ RLtypename: option.value })),
        errors,
      };
    };

    const createBulkValidationError = (message) => ({
      rowNumber: "Upload",
      emailAddress: "",
      userType: "",
      userGroupLabels: "",
      roleLabels: "",
      userGroupIds: [],
      roleNames: [],
      errors: [message],
    });

    const addDuplicateEmailErrors = (rows) => {
      const rowsByEmail = new Map();

      rows.forEach((row) => {
        const email = row.emailAddress.toLowerCase();
        if (email) {
          const matchingRows = rowsByEmail.get(email) || [];
          matchingRows.push(row);
          rowsByEmail.set(email, matchingRows);
        }
      });

      rowsByEmail.forEach((matchingRows, email) => {
        if (matchingRows.length > 1) {
          matchingRows.forEach((row) => {
            row.errors.push(`Duplicate email in upload: ${email}`);
          });
        }
      });

      return rows;
    };

    const resetBulkUploadInput = () => {
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    };

    const handleBulkFileUpload = (event) => {
      const file = event.target.files?.[0];
      if (!file) {
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
          const jsonRows = XLSX.utils.sheet_to_json(firstSheet, { defval: "" });
          const sheetRows = XLSX.utils.sheet_to_json(firstSheet, { header: 1, defval: "" });
          const headers = sheetRows[0] || [];
          const missingHeaders = BULK_TEMPLATE_HEADERS.filter(
            (header) => !headers.includes(header)
          );

          let parsedRows;
          if (missingHeaders.length > 0) {
            parsedRows = [
              createBulkValidationError(
                `Missing required column(s): ${missingHeaders.join(", ")}`
              ),
            ];
          } else if (jsonRows.length === 0) {
            parsedRows = [createBulkValidationError("The uploaded file has no user records")];
          } else {
            parsedRows = addDuplicateEmailErrors(
              jsonRows.map((rawRow, index) => validateBulkRow(rawRow, index + 2))
            );
          }

          setBulkRows(parsedRows);
          setShowBulkModal(true);
        } catch (error) {
          toast.error("Unable to read the uploaded file. Please use the provided template.");
        } finally {
          resetBulkUploadInput();
        }
      };
      reader.readAsArrayBuffer(file);
    };

    const closeBulkModal = () => {
      setShowBulkModal(false);
      setBulkRows([]);
      setIsBulkSubmitted(false);
      resetBulkUploadInput();
    };

    const hasBulkErrors = bulkRows.some((row) => row.errors.length > 0);

    const handleBulkSave = () => {
      if (bulkRows.length === 0 || hasBulkErrors || isBulkSubmitted) {
        return;
      }

      setIsBulkSaving(true);

      const payload = bulkRows.map((row) => ({
        emailAddress: row.emailAddress.toLowerCase(),
        userType: row.userType,
        userGroup: row.userGroupIds,
        rlType: row.roleNames,
        assignUser: emailid,
      }));

      const url = `${process.env.REACT_APP_SERVER_URL}/aipd/bulkRegisterUsers`;
      const header = {
        headers: {
          "oidc-token": passtoken,
        },
      };

      axios
        .post(url, payload, header)
        .then((response) => {
          setIsBulkSaving(false);
          // backend returns 200 with a per-user status, so failures must be read from the body
          const results = Array.isArray(response?.data) ? response.data : [];
          const resultByEmail = new Map(
            results.map((result) => [String(result?.emailAddress || "").toLowerCase(), result])
          );
          const successCount = results.filter((result) => result?.status === "SUCCESS").length;
          const failedCount = payload.length - successCount;

          if (failedCount === 0) {
            closeBulkModal();
            toast.success(`${successCount} users registered successfully`, {
              position: toast.POSITION.BOTTOM_LEFT,
              autoClose: 6000,
            });
            return;
          }

          setBulkRows((rows) =>
            rows.map((row) => {
              const result = resultByEmail.get(row.emailAddress.toLowerCase());
              return {
                ...row,
                apiSuccess: result?.status === "SUCCESS",
                apiMessage:
                  result?.status === "SUCCESS"
                    ? "Registered successfully"
                    : result?.message || "Registration failed",
              };
            })
          );
          setIsBulkSubmitted(true);
          toast.warn(
            `${successCount} user(s) registered, ${failedCount} failed. Check the Issues column for details.`,
            { position: toast.POSITION.BOTTOM_LEFT, autoClose: 8000 }
          );
        })
        .catch((error) => {
          setIsBulkSaving(false);
          toast.error(
            error?.response?.data?.message || error?.response?.data || "Bulk registration failed",
            { position: toast.POSITION.BOTTOM_LEFT, autoClose: 6000 }
          );
        });
    };
  

    const findUsernameFromGmail = (gmailAddress) => {
        const parts = gmailAddress.split("@");
        if (parts.length === 2) {
            const usernameWithDot = parts[0]; // e.g., "nabasundar.rout"
            const usernameParts = usernameWithDot.split(".");
            if (usernameParts.length >= 2) {
                const firstName = capitalize(usernameParts[0]);
                const lastName = capitalize(usernameParts[1]);
                // Handle cases where last name has more than one part
                const lastNameRest = usernameParts.slice(2).join(" ");
                return firstName + " " + lastName + (lastNameRest ? " " + lastNameRest : "");
            } else {
                return "Invalid Gmail address. Must contain both first and last name.";
            }
        } else {
            return "Invalid Gmail address";
        }
    };
    
    // Helper function to capitalize first letter of a string
    const capitalize = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    
  return (
    <div id="userRegId">
       
      <div>

          <div
            style={{ gridGap: "10px", display: "flex", justifyContent: "flex-end", marginBottom: "1rem" }}
          >
            <Button onClick={() => setShowDataRules(true)} style={{ width: "200px" }} className="cancel_btn" type="button">
              Data Rules
            </Button>
            <Button onClick={downloadBulkTemplate} style={{ width: "200px" }} className="cancel_btn" type="button">
              Download Template
            </Button>
            <Button onClick={triggerBulkFileSelect} style={{ width: "200px" }} className="submit_btn" type="button">
              Upload Excel
            </Button>
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleBulkFileUpload}
              style={{ display: "none" }}
              accept=".xlsx,.xls"
            />
          </div>

          <div id="Create_users_id">
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <Row className="mb-3">
                <Form.Group as={Col} md="4" controlId="validationCustom01Email">
                  <Form.Label>Email *</Form.Label>
                  <Form.Control
                    className="validationCustom01Email"
                    autoComplete="off"
                    required
                    type="email"
                    placeholder="Email Address"
                    value={EmailAdress}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <Form.Control.Feedback type="invalid">
                    Email Address is required *
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group as={Col} md="4" controlId="validationCustom02">
                  <Form.Label>User Type *</Form.Label>

                  <Form.Select
                    required
                    value={userType}
                    onChange={(e) => setuserType(e.target.value)}
                  >
                    <option value="Member">Member</option>
                    <option value="Admin">Admin</option>
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    User Type is required *
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group as={Col} md="4" controlId="validationCustom03Pesona">
                  <Form.Label>Group Type *</Form.Label>

                  <Select
                options={personaOptions}
                required
                isMulti
                placeholder="Select Group Types"
                value={selectedOptionsPersona}
                onChange={handleChangePersona}
                className="RlTypesCls"
        
              />

                  {/* <Form.Select
                    required
                    value={userGroup}
                    onChange={(e) => setuserGroup(e.target.value)}
                  >
                    
                  </Form.Select> */}
                  <Form.Control.Feedback type="invalid">
                    Group Type is required *
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>

              <Row className="mb-3">
             
              <Form.Group as={Col} md="4" controlId="validationCustom04RLType">
              <Form.Label>Roles*</Form.Label>

              <Select
                options={roleOptions}
                required
                isMulti
                placeholder="Select Roles"
                value={selectedOptions}
                onChange={handleChange}
                className="RlTypesCls"

        
              />
               <Form.Control.Feedback type="invalid">
               RL Types is required *
                  </Form.Control.Feedback>
              </Form.Group>

               
              
              </Row>

              <div
                style={{ gridGap: "10px", display: "flex", marginTop: "1rem" }}
                className="mb-3"
              >
               
                <Button onClick={resetForm} className="cancel_btn" type="reset">
                  {" "}
                  Reset
                </Button>

                <Button  disabled={isLoading} className="submit_btn" type="submit">
                  
                  {isLoading 
                ? 
                <>
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span style={{paddingLeft:"10px"}}>Adding...</span>
              </> 

                : "Register"}
                </Button>
              </div>
            </Form>
          </div>
        

        {issuccess && (
          <div>
            <Alert
              style={{ position: "absolute", right: "20px", top: "10px" }}
              variant="success"
            >
              <p className="mb-0">User Successfully Registered</p>
            </Alert>
          </div>
        )}

        {iserror && (
          <div>
            <Alert
              style={{ position: "absolute", right: "20px", top: "10px" }}
              variant="danger"
            >
              <p className="mb-0">
                  User already exists
              </p>
            </Alert>
          </div>
        )}

        {iserrorEmail && (
          <div>
            <Alert
              style={{ position: "absolute", right: "20px", top: "10px" }}
              variant="danger"
            >
              <p className="mb-0">
                Please use '@daimlertruck.com' and '@tbdir.com' email id 

              </p>
            </Alert>
          </div>
        )}

        <Dialog
          open={showDataRules}
          onClose={() => setShowDataRules(false)}
          fullWidth
          maxWidth="lg"
          PaperProps={{ className: "rr-manageCard rr-editDialogPaper-DataRules" }}
        >
          <DialogTitle disableTypography className="border-0 rr-deleteModalHeader rr-deleteModalHeaderFlex">
            <h5 className="modal-title mb-0">Data Rules</h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              aria-label="Close"
              onClick={() => setShowDataRules(false)}
            ></button>
          </DialogTitle>

          <DialogContent className="pt-3">
            <ul className="rr-checklist mb-3">
              <li>Use the downloaded template. Do not rename, remove or reorder the column headers.</li>
              <li>Enter user data from row 2 onwards, one user per row, in the first sheet only.</li>
              <li>All columns are mandatory. Rows with any empty cell cannot be saved.</li>
              <li>For columns that allow multiple values, separate the values with a comma (e.g. <b>WASAN, ROLE2</b>).</li>
              <li>The assigning user is taken automatically from the logged-in user and is not required in the file.</li>
            </ul>
            <table className="table rr-table mb-0">
              <thead>
                <tr>
                  <th>Column</th>
                  <th>Rules</th>
                  <th>Example</th>
                </tr>
              </thead>
              <tbody className="rr-deleteModalText">
                <tr>
                  <td>Email</td>
                  <td>
                    Single value. Must be a valid email address with domain <b>@tbdir.net</b> or <b>@daimlertruck.com</b>.
                    The same email must not appear more than once in the file.
                  </td>
                  <td>abc@tbdir.net</td>
                </tr>
                <tr>
                  <td>User Type</td>
                  <td>Single value. Must be either <b>Member</b> or <b>Admin</b>.</td>
                  <td>Member</td>
                </tr>
                <tr>
                  <td>User Group(s)</td>
                  <td>
                    One or more comma-separated values. Each value must be a Group Type name exactly as shown in the
                    Group Type dropdown (not the ID).
                  </td>
                  <td>{personaOptions[6]?.label || "Persona Name"}</td>
                </tr>
                <tr>
                  <td>Role(s)</td>
                  <td>
                    One or more comma-separated values. Each value must be an existing role name as shown in the Roles
                    dropdown.
                  </td>
                  <td>WASAN</td>
                </tr>
              </tbody>
            </table>
          </DialogContent>

          <DialogActions className="border-0 pt-2">
            <button
              type="button"
              className="btn rr-btnPrimary rr-deleteModalActionBtn"
              onClick={() => setShowDataRules(false)}
            >
              Close
            </button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={showBulkModal}
          onClose={closeBulkModal}
          fullWidth
          maxWidth="lg"
          PaperProps={{ className: "rr-manageCard rr-editDialogPaper-DataRules" }}
        >
          <DialogTitle disableTypography className="border-0 rr-deleteModalHeader rr-deleteModalHeaderFlex">
            <h5 className="modal-title mb-0">Confirm Bulk User Registration</h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              aria-label="Close"
              onClick={closeBulkModal}
              disabled={isBulkSaving}
            ></button>
          </DialogTitle>
          <DialogContent className="pt-3">
            <div className="table-responsive">
            <table className="table rr-table mb-0">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Email</th>
                  <th>User Type</th>
                  <th>User Group(s)</th>
                  <th>Role(s)</th>
                  <th>Issues</th>
                </tr>
              </thead>
              <tbody>
                {bulkRows.map((row) => (
                  <tr
                    key={row.rowNumber}
                    style={
                      row.errors.length > 0 || (row.apiMessage && !row.apiSuccess)
                        ? { backgroundColor: "#f8d7da" }
                        : row.apiSuccess
                        ? { backgroundColor: "#d1e7dd" }
                        : undefined
                    }
                  >
                    <td>{row.rowNumber}</td>
                    <td>{row.emailAddress}</td>
                    <td>{row.userType}</td>
                    <td>{row.userGroupLabels}</td>
                    <td>{row.roleLabels}</td>
                    <td style={{ color: row.apiSuccess ? "#0f5132" : "#a70e13" }}>
                      {row.apiMessage || row.errors.join("; ")}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
          </DialogContent>
          <DialogActions className="border-0 pt-2">
            <button
              type="button"
              className="btn rr-btnGhost rr-deleteModalActionBtn"
              onClick={closeBulkModal}
              disabled={isBulkSaving}
            >
              {isBulkSubmitted ? "Close" : "Cancel"}
            </button>
            <button
              type="button"
              className="btn rr-btnPrimary rr-deleteModalActionBtn"
              disabled={isBulkSaving || isBulkSubmitted || hasBulkErrors || bulkRows.length === 0}
              onClick={handleBulkSave}
            >
              {isBulkSaving ? (
                <>
                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  <span style={{ paddingLeft: "10px" }}>Adding...</span>
                </>
              ) : (
                "Save"
              )}
            </button>
          </DialogActions>
        </Dialog>

        <ToastContainer />
      </div>
    </div>
  );
}

export default UserRegistration
